export default __webpack_public_path__ + "static/media/meditations_icon_black.c79fa757.svg";